export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
                d="M10.8333 17.1666H18.2813M10.8333 25.2201H18.2813M21.7188 17.1666H29.1667M10.8333 21.3022H18.2813M21.7188 25.5V21.8491C21.7188 21.5471 21.9753 21.3022 22.2917 21.3022H29.1667"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <circle cx="20" cy="20.5" r="15" stroke="white" strokeWidth="2" />
        </svg>
    );
}
